import { initialize } from 'launchdarkly-js-client-sdk'
import config from '../config/config'

// waitForInitialization() with no argument is unbounded — it only settles once the client
// initializes or initialization fails, so a connection that hangs (ad blocker, corp proxy)
// would leave the client and its streaming connection open forever.
const INITIALIZATION_TIMEOUT_SECONDS = 5

// Some flags are targeted in LaunchDarkly by a `market` context kind keyed on branch id, so they
// can't be read through the app-wide FlagProvider (which only identifies a `user` context).
// Resolves `false` — the same default `variation` falls back to — when the client can't
// initialize, so callers never have to handle a rejection.
export default async function checkMarketFlag( flagKey: string, branchId: string ): Promise<boolean> {
	const client = initialize( config.LAUNCH_DARKLY_CLIENT_ID, { key: String( branchId ), kind: 'market' } )

	try {
		await client.waitForInitialization( INITIALIZATION_TIMEOUT_SECONDS )
		return client.variation( flagKey, false ) as boolean
	} catch {
		return false
	} finally {
		await client.close().catch( () => undefined )
	}
}
